import React, { ReactElement, useEffect } from 'react';
import { Loading, Result } from '@dexma/ui-components';
import { isSome } from 'fp-ts/Option';

import i18n from 'asset/translation';
import { usePermissions, dispatchPermissions } from 'adapter/in/dashboards/context/Permissions';

type PermissionsProps = {
    children: ReactElement | ReactElement[];
};

export const PermissionsContainer = (props: PermissionsProps): ReactElement => {
    const { children } = props;
    const { read } = dispatchPermissions();
    const { permissions, error: hasErrorPermissions } = usePermissions();

    useEffect(() => {
        read();
    }, []);

    let result = <Loading isLoading size={50} />;

    if (isSome(permissions)) {
        result = <> {[children]} </>;
    }

    if (isSome(hasErrorPermissions)) {
        result = <Result variant='error' title={i18n.t('common.errorWrong')} info={i18n.t('common.errorWrongInfo')} icon='bot-dead' />;
    }
    return result;
};
